export const css = {
    root: '_2K10J9-z',
    ' _key': 'certwise-theme/certwise/variants/epm'
};
export default css;
